<section class="relative">
    <div class="absolute post-16 posr-16">
      <a mat-stroked-button paint="primary" routerLink="/faqs">
        <span>Switch to </span>
        <mat-icon svgIcon="logo:england" iconPositionEnd></mat-icon>
      </a>
    </div>
    <h1 class="mat-display-1">Mistoqsijiet Ġenerali</h1>
  </section>
  <div class="content">
    <mat-accordion>
      <div>
        <h2 paint="primary" extrabold>Ġenerali</h2>
        <mat-expansion-panel [expanded]="true" [expanded]="!fragment() || fragment() == 'cloudigo'" (afterExpand)="onExpand('cloudigo')">
          <mat-expansion-panel-header>
            <h3 id="cloudigo">X’inhi cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                cloudigo hija applikazzjoni mimlija offerti li tgħinek tiffranka l-flus mingħand ħafna ħwienet tal-ħwejjeġ, ristoranti u ħafna aktar. L-applikazzjoni ta’ cloudigo tista’ tniżżilha b’xejn fuq <a [href]="ios" target="_blank">iOS</a> u <a
                [href]="android" target="_blank">Android</a> jew fuq <a
                routerLink="/">www.cloudigo.app</a>.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'get'" (afterExpand)="onExpand('get')">
          <mat-expansion-panel-header>
            <h3 id="get">X'nagħmel bil-cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Meta tniżżel l-app u toħloq account, ikollok aċċess għal <span class="font-bold">offerti</span> minn mijiet ta' ditti u ristoranti.
              <br /><br />
              Ladarba tagħmel dan, ser tara offerti mmarkati blu u ħomor.
            </p>
            <ul>
              <li>
                  L-offerti <span paint="primary">blu</span> jistgħu jintużaw bla ħlas, filwaqt li
              </li>
              <li>
                  L-offerti <span paint="warn">ħomor</span> jistgħu jintużaw minn klijenti tal-Premium biss.
              </li>
            </ul>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'download'" (afterExpand)="onExpand('download')">
          <mat-expansion-panel-header>
            <h3 id="download">Kif nista' nniżżel u nirreġistra ma' cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Kull ma trid tagħmel hu li tirreġistra fuq <a routerLink="/signup">il-websajt tagħna</a>, jew <a routerLink="/get-the-app">tniżżel l-app b'xejn</a>. Tista' wkoll iżżur l-App Store jew Google Play Store fuq l-ismartphone tiegħek biex tniżżel l-app.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'premium'" (afterExpand)="onExpand('premium')">
          <mat-expansion-panel-header>
            <h3 id="premium">X'inhu cloudigo Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                cloudigo Premium huwa abboniment ta' kull xahar jew ta' kull sena li jippermettilek tuża l-offerti ħomor fuq l-app. Dawn l-offerti <span paint="warn">ħomor</span> jinkludu:
            </p>
              <ul>
                <li>Skontijiet bla limitu</li>
                <li>2 for 1 fuq ‘main courses’</li>
                <li>Skontijiet sa 50% u ħafna aktar</li>
              </ul>
            <p>
              Tista tagħfas <a [routerLink]="['/premium']">hawn</a> biex titgħallem aktar
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == '2for1'" (afterExpand)="onExpand('2for1')">
          <mat-expansion-panel-header>
            <h3 id="2for1">Hemm offerti 2 for 1 fuq cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Tista' tara lista sħiħa ta’ Offerti 2 for 1 fuq cloudigo billi tiftaħ l-applikazzjoni u tiskrollja 'l isfel lejn it-taqsima ta’ Offerti 2 for 1. Dawn jistgħu jintużaw minn klijenti tal- Premium biss.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'contact'" (afterExpand)="onExpand('contact')">
          <mat-expansion-panel-header>
            <h3 id="contact">Kif nikkuntattja lil cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Tista' tikkuntattjana permezz ta' email, facebook messenger jew il-formola ta' kuntatt tagħna:
            </p>
            <ul>
              <li>
                  Formola ta' kuntatt: <a routerLink="/contact-us">cloudigo.app/contact-us</a>
              </li>
              <li>
                  Email: <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
              </li>
              <li>
                  Facebook: <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">facebook.com/cloudigo</a>
              </li>
            </ul>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'location'" (afterExpand)="onExpand('location')">
          <mat-expansion-panel-header>
            <h3 id="location">Fejn huma l-uffiċċji ta’ cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
              L-uffiċċji tagħna jinsabu ‘cloudigo Ltd, 90, Uffiċċju 1, Livell 1, Triq Psaila, Birkirkara.’ Ninsabu bejn Europharma u Andrew’s Bar, fuq showroom tal-karozzi bl-isem Caro Motors.
              <br/><br/>
  
              Ħinijiet tal-ftuħ:
            </p>
            <ul>
                <li>
                    Mit-Tnejn sal-Ġimgħa
                </li>
                <li>
                    9am - 5pm
                </li>
              </ul>
  
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'comm_preferences'" (afterExpand)="onExpand('comm_preferences')">
          <mat-expansion-panel-header>
            <h3 id="comm_preferences">Kif nimmaniġġja l-informazzjoni li nircievi mingħandkom?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Biex timmaniġġja l-preferenzi tal-komunikazzjoni tiegħek, <a routerLink="/login">idħol fl-app ta’ cloudigo</a> u <a routerLink="/profile">żur il-profil tiegħek</a>. Fil-profil tal-kont tiegħek, tista’ tixgħel u titfi <a routerLink="/profile/preferences">s-settings tal-komunikazzjoni</a> relatati ma' cloudigo
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'forget_password'" (afterExpand)="onExpand('forget_password')">
          <mat-expansion-panel-header>
            <h3 id="forget_password">X'nagħmel jekk ninsa l-password tiegħi?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Faċli ħafna! Idħol f’din <a routerLink="/recovery/forgot">link hawn</a> u ddaħħal l-indirizz elettroniku tiegħek.
              <br/><br/>
              Jekk ma tirċivix email mingħandna biex tirkupra l-password, jekk jogħġbok ikkuntattjana billi tibgħat email lil <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'change_email'" (afterExpand)="onExpand('change_email')">
          <mat-expansion-panel-header>
            <h3 id="change_email">Kif nibdel l-indirizz elettroniku tal-kont tiegħi?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Jekk trid tibdel l-indirizz elettroniku assoċjat mal-kont tal-cloudigo tiegħek, jekk jogħġbok ibgħatilna email fuq <a target="_top" rel="noreferrer" href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'blue_offers'" (afterExpand)="onExpand('blue_offers')">
          <mat-expansion-panel-header>
            <h3 id="blue_offers">Xi jfissru l-offerti mmarkati bil-blu?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                L-offerti mmarkati bil-<span paint="primary">blu</span> jirreferu għal skontijiet li jistgħu jintużaw bla ħlas. Normalment tkun offerta ta’ 10% li tista tintuża b’xejn darba fis-sena.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'locked_offers'" (afterExpand)="onExpand('locked_offers')">
          <mat-expansion-panel-header>
            <h3 id="locked_offers">Għaliex hemm offerti b’katnazz fuq cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Dawn huma offerti <span paint="warn">ħomor</span> li jistgħu jintużaw biss minn klijenti tal- Premium.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'red_offers'" (afterExpand)="onExpand('red_offers')">
          <mat-expansion-panel-header>
            <h3 id="red_offers">Xi jfissru l-offerti ħomor?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                L-offerti mmarkati bl-<span paint="warn">aħmar</span> jirreferu għal skontijiet tal-Premium li jistgħu jintużaw biss minn klijenti tal-Premium biss. Dawn jinkludu:
            </p>
            <ul>
                <li>
                    Skontijiet bla limitu
                </li>
                <li>
                    2 for 1 fuq ‘main courses’
                </li>
                <li>
                    Skontijiet sa 50% u ħafna aktar
                </li>
              </ul>
            <p>
              Biex issir membru tal-Premium, agħfas <a [routerLink]="['/premium']">hawn</a>
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'grey_offers'" (afterExpand)="onExpand('grey_offers')">
          <mat-expansion-panel-header>
            <h3 id="grey_offers">Xi jfissru l-offerti l-griżi?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Jekk l-offerta fuq l-app hija griża u l-buttuna turi ‘<span class="font-bold">NOT VALID TODAY</span>’, jew jekk fil-paġna tal-offerta fil-qiegħ ikun hemm buttuna griża li turi ‘<span class="font-bold">NOT VALID TODAY</span>’, dan ifisser li l-offerta mhix valida u ma tistax jiġi użata f’dik il-ġurnata partikolari. Jekk l-offerta turi ħin speċifiku li fih l-offerta hija valida, dan ifisser li l-offerta ma tistax tiġi użata barra minn dawn is-sigħat.
              <br/><br/>
              Jekk l-offerta fuq l-app hija griża u l-buttuna turi ‘<span class="font-bold">USED</span>’, jew jekk fil-paġna tal-offerta fil-qiegħ ikun hemm buttuna griża li turi ‘<span class="font-bold">USED</span>’, dan ifisser li l-offerta intużat u ma tistax terġa’ tintuża qabel ma jgħaddi l-perjodu ta’ żmien meħtieġ biex l-offerta terġa tixgħel.
  
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'gift'" (afterExpand)="onExpand('gift')">
          <mat-expansion-panel-header>
            <h3 id="gift">Irbaħt rigal minn kwizz fuq l-app cloudigo. X'irrid nagħmel?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Jekk irbaħt rigal minn kwizz fuq cloudigo:
            </p>
            <ol>
                <li>
                    Iftaħ l-<span class="font-bold">applikazzjoni ta’ cloudigo</span>
                </li>
                <li>
                    Ikklikkja fuq l-buttuna li hija <span class="font-bold">forma ta’ Kartiera (‘Wallet’)</span> fin-naħa ta' fuq tal-lemin
                </li>
                <li>
                    Agħfas fuq <span class="font-bold">Vouchers</span>
                </li>
                <li>
                    Iċċekkja <span class="font-bold">fejn</span> tista’ tuża l-vawċer u żur il-ħanut jew ristorant rispettiv
                </li>
                <li>
                    Agħfas fuq <span class="font-bold">Get Code</span>
                </li>
                <li>
                    Skennja l-<span class="font-bold">kodiċi QR</span> ipprovdut mill-ħanut jew ir-ristorant
                </li>
              </ol>
            <p>
              Jekk il-vawċer irid jissarraf fl-uffiċċju tal-cloudigo, jekk jogħġbok żur l-uffiċċju tal-cloudigo f’dan l-indirizz  mit-Tnejn sal-Ġimgħa bejn id-9am u l-4pm;
              <br/><br/>
              cloudigo Ltd, 90, Office 1, Level 1, Psaila Street, Birkirkara.  
              <br/>
              L-uffiċċju tagħna jinstab fi ‘cloudigo Ltd, 90, Uffiċċju 1, Livell 1, Triq Psaila, Birkirkara.’ Ninsabu bejn Europharma u Andrew’s Bar, fuq showroom tal-karozzi bl-isem Caro Motors.
  
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'delete'" (afterExpand)="onExpand('delete')">
          <mat-expansion-panel-header>
            <h3 id="delete">Irrid inħassar il-kont ta’ cloudigo tiegħi. X'irrid nagħmel?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Jekk jogħġbok ibgħat email lil <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a> u wieħed mill-membri tat-tim tagħna jgħinek.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <!-- !PREMIUM SECTION -->
        <h2 paint="warn" extrabold>Mistoqsijiet dwar cloudigo Premium</h2>
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'premium'" (afterExpand)="onExpand('premium')">
          <mat-expansion-panel-header>
            <h3 id="cloudigo-premium">Għaliex għandi nixtri cloudigo Premium? </h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                cloudigo Premium jagħtik aċċess esklussiv għal:
            </p>
            <ul>
                <li>
                    Skontijiet bla limitu
                </li>
                <li>
                    2 for 1 fuq ‘main courses’
                </li>
                <li>
                    Skontijiet sa 50% u ħafna aktar
                </li>
              </ul>
            <p>
              Aktar informazzjoni <a [routerLink]="['/premium']">hawn</a>.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'brands'" (afterExpand)="onExpand('brands')">
          <mat-expansion-panel-header>
            <h3 id="premium-brands">Xi ħwienet u restoranti hemm fuq cloudigo Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Tista' tara lista sħiħa ta’ ħwienet u ristoranti fuq cloudigo <a routerLink="/premium/catalogue">hawn</a>.
                Biex tara x'offerti għandna, jekk jogħġbok ikklikkja fuq il-logo.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'cost'" (afterExpand)="onExpand('cost')">
          <mat-expansion-panel-header>
            <h3 id="premium-cost">Kemm jiswa biex issir membru Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Tista’ tħallas fis-sena. Aktar informazzjoni <a [routerLink]="['/premium']">hawn</a> 
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'buy'" (afterExpand)="onExpand('buy')">
          <mat-expansion-panel-header>
            <h3 id="premium-buy">Kif nista nixtri l-Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Sabiex issir klijent tal-Premium trid:
            </p>
            <ol>
                <li>
                    Tniżżel l-app fuq <a [href]="ios">iOS</a> jew <a [href]="android">Android</a> u oħloq account
                </li>
                <li>
                    Ikklikkja fuq l-buttona li hija <span class="font-bold">forma ta’ kuruna</span> fil-menu t’isfel
                </li>
                <li>
                    Daħħal id-<span class="font-bold">dettalji tal-ħlas</span> tiegħek
                </li>
                <li>
                    Segwi l-istruzzjonijiet rispettivi dwar <span class="font-bold">3D secure</span> mill-bank tiegħek u ibda ffranka! (Jista' jkun il-każ li jkollok bżonn tawtentika t-transazzjoni tiegħek billi ddaħħal kodiċi pin mibgħut permezz ta' SMS jew notifika fuq l-app tal-bank tiegħek).
                </li>
              </ol>
            <p>
              Jekk għandek xi kupun biex tixtri cloudigo Premium b'rata mnaqqsa, jekk jogħġbok <a routerLink="/how-to-coupon">ikklikkja hawn</a> biex issegwi l-istruzzjonijiet.
  
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'validity'" (afterExpand)="onExpand('validity')">
          <mat-expansion-panel-header>
            <h3 id="premium-validity">Għal kemm żmien huwa validu l-Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <ul>
              <li>
                  Sena: L-abboniment huwa <span class="font-bold">validu għal sena mid-data tax-xiri</span> u tiġġedded awtomatikament kull sena sakemm ma tikkanċellax skont it-Termini u l-Kundizzjonijiet tagħna.
              </li>
            </ul>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'creditcard'" (afterExpand)="onExpand('creditcard')">
          <mat-expansion-panel-header>
            <h3 id="creditcard">Huwa sigur li ddaħħal id-dettalji tal-karta ta' kreditu tiegħi?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Huwa sigur li ddaħħal id-dettalji tal-karta tal-kreditu tiegħek. Bħala cloudigo nieħdu dawn l-affarijiet b’serjeta’ kbira. Nużaw ukoll sistemi fdati ħafna biex nassiguraw it-transazzjonijiet tagħkom.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'cloudigo-save'" (afterExpand)="onExpand('cloudigo-save')">
          <mat-expansion-panel-header>
            <h3 id="cloudigo-save">Kemm niffranka bil-cloudigo Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Trid tkun taf kemm tista' tiffranka flus bi cloudigo Premium? Uża <a routerLink="/premium/yearly/calculator">l-kalkolatur tagħna ta' tfaddil</a> b'xejn biex issir taf!
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'website'" (afterExpand)="onExpand('website')">
          <mat-expansion-panel-header>
            <h3 id="premium-website">cloudigo Premium huwa aċċessibbli mill-websajt ta’ cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Tista' tabbona għal cloudigo Premium fuq il-<a [routerLink]="['/premium']">websajt ta' cloudigo</a>, pero, tista' tuża l-offerti Premium mill-<a routerLink="/get-the-app">applikazzjoni ta’ cloudigo</a> biss.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <!-- !RESTAURANTS/SHOPS/OFFERS SECTION -->
        <h2 paint="primary" extrabold>Ristoranti, Ħwienet & Offerti</h2>
  
        <mat-expansion-panel [expanded]="fragment() == 'information'" (afterExpand)="onExpand('information')">
          <mat-expansion-panel-header>
            <h3 id="offer-information">Kif insib aktar informazzjoni dwar offerta, ristorant jew ħanut?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Tista' faċilment titgħallem aktar dwar l-offerta billi tikklikkja fuq karta tal-offerta. Se tidher deskrizzjoni dettaljata tal-offerta u t-termini u l-kundizzjonijiet rilevanti. Tista' wkoll titgħallem aktar dwar ir-ristorant jew il-ħanut billi tikklikkja fuq il-logo.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'use'" (afterExpand)="onExpand('use')">
          <mat-expansion-panel-header>
            <h3 id="offer-use">Kif nuża l-offerti fuq l-app?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <ol>
              <li>
                  Fittex jew ikklikkja fuq l-<span class="font-bold">offerta</span> li trid tuża
              </li>
              <li>
                  Ikklikkja fuq ‘<span class="font-bold">Get Code</span>’
              </li>
              <li>
                  Se tidher kamera għalik biex tiskennja l-<span class="font-bold">kodiċi QR</span> ipprovdut mill-ħanut jew ir-ristorant. Jekk il-kamera tiegħek ma taħdimx, sempliċement ikklikkja fuq 'Tippreferi li tuża kodiċi PIN minflok? Ikklikkja hawn’ u r-rappreżentant tal-ħanut jew ristorant jagħtik kodiċi pin b’4 numri.
              </li>
              <li>
                  Ladarba l-kodiċi jiġi vvalidat, uri l-kodiċi finali fuq l-iskrin iswed lill-kaxxier u <span class="font-bold">gawdi</span> l-iffrankar tiegħek.
              </li>
            </ol>  
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'time'" (afterExpand)="onExpand('time')">
          <mat-expansion-panel-header>
            <h3 id="offer-use-time">Meta għandi ngħid lir-ristorant jew lill-ħanut li rrid nuża cloudigo?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Għall-biċċa l-kbira tal-ħwienet, huwa importanti li qabel tħallas, tinforma lill-kaxxier li għandek cloudigo. Kun żgur li għandek il-kodiċi lest fuq l-app cloudigo.
              <br/><br/>
              Fir-rigward tar-ristoranti, xi wħud jeħtieġu li jsemmu cloudigo mal-prenotazzjoni, filwaqt li oħrajn jeħtieġu li jsemmu cloudigo mal-wasla fir-ristorant. Dan se jkun stipulat fit-termini u l-kundizzjonijiet tal-offerta. Madankollu, dejjem semmi cloudigo meta titlob lir-ristorant għall-kont, sabiex l-iskont ikun jista’ jiġi applikat immedjatament.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'denial'" (afterExpand)="onExpand('denial')">
          <mat-expansion-panel-header>
            <h3 id="offer-denial">Ir-ristorant jew il-ħanut mhux jaċċetta l-iskont tal-cloudigo tiegħi..</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Fil-każ li ristorant jew ħanut ma jaċċettax il-kodiċi tal-offerta tiegħek għal xi raġuni, kun żgur li taqra t-termini u l-kundizzjonijiet fuq il-karta tal-offerta biex tiċċara l-validità tal-offerta. Jekk għadek tesperjenza problemi bil-ħanut jew ir-ristorant, jekk jogħġbok ikkuntattjana direttament fuq <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">Facebook</a> billi tibgħatilna messaġġ privat, jew ibgħat email lil <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a> u ninvestigaw aħna.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'booking'" (afterExpand)="onExpand('booking')">
          <mat-expansion-panel-header>
            <h3 id="offer-booking">Għaliex xi ristoranti jew ħwienet tal-ikel jitolbu li tibbukkja minn qabel?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Xi ristoranti jindikaw fit-termini u kundizzjonijiet li jeħtieġu li l-membri jibbukkjaw minn qabel. Dan għaliex jekk cloudigo ma tkunx ssemmiet qabel u jiġi l-kont, il-maniġer tar-restorant jew il-wejter ikollu jirriproduċi l-kont; li jistgħu jieħdu ħafna ħin. Jekk ir-ristorant huwa diġà konxju li inti membru cloudigo, huma jistgħu jikkalkulaw il-kont u japplikaw l-iskont kif suppost.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel [expanded]="fragment() == 'online'" (afterExpand)="onExpand('online')">
          <mat-expansion-panel-header>
            <h3 id="offer-online">Kif nuża offerta online?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <ol>
              <li>
                <span class="font-bold">Ikklikkja</span> fuq l-offerta online
              </li>
              <li>
                  Agħfas fuq <span class="font-bold">‘Shop Now’</span>
              </li>
              <li>
                  Se tidher kodiċi fuq <span class="font-bold">pop-up</span> u l-<span class="font-bold">website</span> tal-ħanut online rispettiv se tinfetaħ fi browser separat
              </li>
              <li>
                  Agħżel il-prodotti li trid
              </li>
              <li>
                  Daħħal il-<span class="font-bold">kodiċi</span> li rajt fuq il-pop-up tal-app ta’ cloudigo fil-kaxxa tal-kupun fil-websajt tal-ħanut
              </li>
            </ol>
          </ng-template>
        </mat-expansion-panel>
  
        <!-- !BILLING SECTION -->
        <h2 paint="warn" extrabold>Ħlas</h2>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'payment'" (afterExpand)="onExpand('payment')">
          <mat-expansion-panel-header>
            <h3 id="cloudigo-payment">Liema metodi ta' ħlas nista' nuża biex nixtri cloudigo Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Naċċettaw Mastercard u VISA
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'failed'" (afterExpand)="onExpand('failed')">
          <mat-expansion-panel-header>
            <h3 id="payment-failed">Il-pagament tiegħi m’għaddiex, x'għandi nagħmel?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Hemm numru ta’ raġunijiet għalfejn dan jista’ jiġri.
              <br/><br/>
              L-aktar raġunijiet komuni huma:
            </p>
            <ul>
                <li>
                    Id-dettalji tal-card ma ddaħħlux b'mod korrett
                </li>
                <li>
                    Il-card skadiet
                </li>
                <li>
                    M'għandekx fondi biżżejjed
                </li>
              </ul>
            <p>
              Jekk jogħġbok iċċekkja d-dettalji tal-card tiegħek u erġa' pprova. Jekk jibqa’ ma jirnexxielekx jekk jogħġbok ikkuntattjana fuq <a target="_top" rel="noreferrer" href="https://facebook.com/cloudigo">Facebook</a> jew ibgħat email lil <a href="mailto:support@cloudigo.app">support&#64;cloudigo.app</a>.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'billing'" (afterExpand)="onExpand('billing')">
          <mat-expansion-panel-header>
            <h3 id="cloudigo-billing">Kif nibdel id-dettalji tal-ħlas tiegħi jew nżid card ġdida?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Sabiex tibdel id-dettalji tal-ħlas tiegħek, idħol fil-profil mill-applikazzjoni tiegħek u kklikkja fuq <a routerLink="/profile/billing">Billing Details</a>. Biex żżid card ġdida, agħfas fuq il-buttuna ‘Add another payment method’
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'coupon'" (afterExpand)="onExpand('coupon')">
          <mat-expansion-panel-header>
            <h3 id="coupon">Kif nuża kupun jew kodiċi promozzjonali?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
              <ol>
                <li>
                    Qabel tħallas, daħħal il-kodiċi tal-kupun mogħti tiegħek fil-kaxxa meħtieġa biex tapplika l-offerta.
                </li>
                <li>
                    Wara li tikklikkja fuq Li jmiss, daħħal id-dettalji tal-ħlas tiegħek
                </li>
                <li>
                    Lesti it-transazzjoni tiegħek
                </li>
              </ol>
            <p>
              Għal aktar istruzzjonijiet, <a routerLink="/how-to-discount-code">ikklikkja hawn</a>.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'renewal'" (afterExpand)="onExpand('renewal')">
          <mat-expansion-panel-header>
            <h3 id="renewal">Meta se nerġa' niġi ċċarġjat għal Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                L-abbonament tiegħek jiġġedded <a class="font-bold">kull sena</a>. Għalhekk il-card tiegħek se tiġi ċċarġjata kull sena skont it-Termini u l-Kundizzjonijiet tagħna.
            </p>
          </ng-template>
        </mat-expansion-panel>
  
        <mat-expansion-panel class="premium" [expanded]="fragment() == 'cancel'" (afterExpand)="onExpand('cancel')">
          <mat-expansion-panel-header>
            <h3 id="premium-cancel">Kif nista' nikkanċella l-abboniment tiegħi mal-cloudigo Premium?</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <p>
                Sabiex twaqqaf l-abbonament tiegħek ta' cloudigo Premium milli jiġġedded awtomatikament:
            </p>
            <ol>
                <li>
                    Idħol fl-applikazzjoni tal-<span class="font-bold">cloudigo</span>
                </li>
                <li>
                    Żur il-<span class="font-bold">profil tal-kont tiegħek</span> u skrollja 'l isfel
                </li>
                <li>
                    Ikklikkja fuq <span class="font-bold">‘Subscription’</span> u kklikkja fuq <span class="font-bold">‘Change Plan’</span>.
                </li>
              </ol>
            <p>
              Imbagħad tkun tista' tikkanċella l-Pjan tal-Premium tiegħek u telqeb għall-Pjan Bażiku ta' cloudigo. Dan ifisser li l-Pjan Premium tiegħek cloudigo mhux se jerġa jiġġedded.
              <br/><br/>
              Madankollu, xorta jkollok aċċess għall-Cloudigo Premium Plan tiegħek sad-data ta' skadenza indikata. Fid-data ta' skadenza msemmija, il-kont tiegħek jiġi degradat għall-Pjan Bażiku ta' cloudigo. Dan huwa skond il-<a routerLink="/terms-and-conditions#cancellation">Politika ta' Kanċellazzjoni</a> tagħna li tinsab fit-Termini u Kundizzjonijiet tagħna.
            </p>
          </ng-template>
        </mat-expansion-panel>

      </div>
    </mat-accordion>
  </div>